import { Box, Button, Grid2, Typography, useColorScheme, useMediaQuery, useTheme } from "@mui/material"
import StarsFilled from "./assets/StarsFilled";
import SoopraLogo from "../../svg/SoopraLogo";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { USER_TYPE } from "../../config/const";


const Footer: React.FC = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  const { mode, systemMode } = useColorScheme();
  const navigate = useNavigate();
  const { authUser, setLoginModalVisible } = useAuth();

  const isLightMode = ( mode === 'light' || (mode === 'system' && systemMode === 'light'));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        gap: 0,
      }}
    >
      <Box
        sx={[{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        },
        isLightMode ? {
          backgroundImage: 'linear-gradient(#3368EE3B, #3D82F53B, #718AE83B, #213BE23B)',
        } : {
          backgroundColor: theme.palette.background["container-3"],
        }
      ]}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            alignItems: 'center',
            px: 1.5,
            py: 6,
            gap: 3,
            maxWidth: 'lg',
          }}
        >
          <SoopraLogo
            color={theme.palette.primary.main}
          />

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Typography variant="h6">
              Ready to scale yourself?
            </Typography>
            <Typography variant="body1" color="text.secondary">
              You've spent years building your knowledge — now let it work for you.
            </Typography>
          </Box>

          <Button
            variant="contained"
            size="large"
            sx={{
              width: 'fit-content',
            }}
            startIcon={<StarsFilled
              color={theme.palette.primary.contrastText}
            />}
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
              if (authUser) {
                if (authUser.userType === USER_TYPE.CREATOR) {
                  navigate(`/${authUser.userName}`)
                } else {
                  navigate('/creator-onboarding')
                }
              } else {
                setLoginModalVisible({
                  isOpen: true,
                  formType: 'signup',
                  currentStep: 1,
                })
              }
            }}
            href={authUser ? '/creator-onboarding' : null}
          >
            Create my AI persona
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default Footer;